import React from 'react';
import PropTypes from 'prop-types';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

const LetterCombinationsFilterMenu = props => {
  return (
    <Menu
      elevation={0}
      open={props.open}
      anchorEl={props.anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      onClose={props.handleRequestClose}
      keepMounted
    >
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('LONG_A_DIGRAPHS')}>Long A Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('LONG_E_DIGRAPHS')}>Long E Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('LONG_I_DIGRAPHS')}>Long I Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('LONG_O_DIGRAPHS')}>Long O Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('ODD_DIGRAPHS')}>Odd Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('DIPHTHONGS')}>Diphthongs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('R_CONTROLLED_VOWELS')}>R-Controlled Vowels</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('ODD_R_CONTROLLED_VOWELS')}>Odd R-Controlled Vowels</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('OTHER_ODDBALLS')}>Other Oddballs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('CONSONANT_DIGRAPHS')}>Consonant Digraphs</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('DOUBLES')}>Doubles</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('INFLECTIONAL_ENDINGS')}>Inflectional Endings</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('PREFIXES')}>Prefixes</MenuItem>
      <MenuItem onClick={() => props.handleClickFilterLetterCombinationsPattern('SUFFIXES')}>Suffixes</MenuItem>
    </Menu>
  );
};

LetterCombinationsFilterMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.object,
  handleRequestClose: PropTypes.func.isRequired,
  handleClickFilterLetterCombinationsPattern: PropTypes.func.isRequired,
};

export default LetterCombinationsFilterMenu;
